import React, { useEffect, useRef, useState } from 'react'
import {
  CCol, CRow, CForm, CFormLabel, CFormSelect, CButton, CAlert,
  CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter,
} from '@coreui/react'
import { api, currentUser } from '../api/client'
import WwGrid, { WwColumn } from '../components/ww/WwGrid'
import { usePendiente } from '../components/ww/pendiente'
import CIcon from '@coreui/icons-react'
import { cilUser, cilLockLocked } from '@coreui/icons'
import { CCard, CCardHeader, CCardBody } from '@coreui/react'

const columnas: WwColumn[] = [
  { key: 'supervisorCodigo', title: 'Codigo', type: 'number' },
  { key: 'empresaCodigo', title: 'Empresa Codigo' },
  { key: 'supervisorNombre', title: 'Nombre' },
  { key: 'supervisorLibreValor1', title: 'Libre Valor1', type: 'currency' },
  { key: 'supervisorLIbreValor2', title: 'Libre Valor2', type: 'currency' },
  { key: 'supervisorLibreNumerico1', title: 'y Modificar?', type: 'bool' },
  { key: 'supervisorlibreCaracter1', title: 'Caracter1' },
  { key: 'supervisorLibreCaracter2', title: 'Libre Caracter2' },
]

// Supervisores — réplica de supervisorgeneral.cs:55 (supervisorgeneral GX).
const SupervisorPage: React.FC = () => {
  const user = currentUser()
  const empresa = user?.companyId ?? '01'
  const [rows, setRows] = useState<any[]>([])
  const formRef = useRef<HTMLFormElement>(null)
  const [cargando, setCargando] = useState(true)
  const [error, setError] = useState('')
  const [abierto, setAbierto] = useState(false)
  const [guardando, setGuardando] = useState(false)
  const [errorModal, setErrorModal] = useState('')
  const { aviso, setAviso } = usePendiente()
  const [form, setForm] = useState({
    supervisorNombre: '',
    libreValor1: 0, libreValor2: 0, libreNumerico1: 0,
    libreCaracter1: '', libreCaracter2: '',
  })
  // Fila en edición (supervisorww.cs:2377 'DO UPDATE' → webobject supervisor Mode="UPD")
  const [editando, setEditando] = useState<any | null>(null)
  // [RGM] Usuarios de la empresa para el SELECT del usuario (SupervisorNombre
  // es el UsuarioCodigo — FK ISUPERVISOR2 — decisión Rafael: el form usa el
  // mismo select que el cobrador; antes era un input de texto libre).
  const [usuarios, setUsuarios] = useState<{ usuarioCodigo: string; usuarioNombre: string }[]>([])
  useEffect(() => {
    api.get<any[]>(`/usuarios?empresa=${empresa}`).then(setUsuarios).catch(() => undefined)
  }, [empresa])

  const cargar = () => {
    setCargando(true)
    api.get<any[]>(`/supervisores?empresa=${empresa}`)
      .then(setRows)
      .catch((e: any) => setError(e.message))
      .finally(() => setCargando(false))
  }
  useEffect(cargar, [empresa])

  const abrirNuevo = () => {
    setEditando(null)
    setErrorModal('')
    setForm({
      supervisorNombre: '', libreValor1: 0, libreValor2: 0, libreNumerico1: 0,
      libreCaracter1: '', libreCaracter2: '',
    })
    setAbierto(true)
  }

  // Modificar (supervisorww.cs:2377-2383): carga la fila. La llave
  // SupervisorCodigo/EmpresaCodigo no cambia.
  const abrirEditar = (fila: any) => {
    setErrorModal('')
    setEditando(fila)
    setForm({
      supervisorNombre: fila.supervisorNombre ?? '',
      libreValor1: fila.supervisorLibreValor1 ?? 0,
      libreValor2: fila.supervisorLIbreValor2 ?? 0,
      libreNumerico1: fila.supervisorLibreNumerico1 ?? 0,
      libreCaracter1: fila.supervisorlibreCaracter1 ?? '',
      libreCaracter2: fila.supervisorLibreCaracter2 ?? '',
    })
    setAbierto(true)
  }

  const crear = async (e: React.FormEvent) => {
    e.preventDefault()
    setErrorModal('')
    setError('')
    setGuardando(true)
    try {
      const body = {
        empresaCodigo: empresa,
        supervisorNombre: form.supervisorNombre,
        libreValor1: Number(form.libreValor1) || 0,
        libreValor2: Number(form.libreValor2) || 0,
        libreNumerico1: Number(form.libreNumerico1) || 0,
        libreCaracter1: form.libreCaracter1 || undefined,
        libreCaracter2: form.libreCaracter2 || undefined,
      }
      if (editando) {
        // UPD: la llave va en la URL (supervisor_bc.cs:420-460, BC000Q9)
        await api.put(`/supervisores/${editando.supervisorCodigo}?empresa=${empresa}`, body)
      } else {
        await api.post('/supervisores', body)
      }
      setAbierto(false)
      setEditando(null)
      cargar()
    } catch (err: any) {
      setErrorModal(err.message)
      setError(err.message)
    } finally {
      setGuardando(false)
    }
  }

  // Eliminar (supervisorww.cs:2385-2393 'DO DELETE'): el backend replica
  // OnDeleteControls0Q23 (supervisor_bc.cs:530-534, BC000Q12) → 409 si hay Zonas.
  const eliminar = (fila: any) => {
    if (!window.confirm(`¿Eliminar el supervisor ${fila.supervisorCodigo}?`)) return
    api.delete(`/supervisores/${fila.supervisorCodigo}?empresa=${empresa}`)
      .then(() => {
        setAviso('Supervisor eliminado.')
        cargar()
      })
      .catch((e: any) => setError(e.message))
  }

  const [totalReg, setTotalReg] = useState(rows.length)
  return (
    <>
      <CRow className="mb-4">
        <CCol>
          <h4>Supervisor</h4>
          <small className="text-body-secondary">{totalReg} {totalReg === 1 ? 'registro' : 'registros'}</small>
        </CCol>
      </CRow>
      {error && <CAlert color="danger">{error}</CAlert>}
      {aviso && <CAlert color="warning" dismissible onClose={() => setAviso('')}>{aviso}</CAlert>}

      <WwGrid
        title="Supervisor"
        columns={columnas}
        rows={rows}
        onTotalChange={setTotalReg}
        loading={cargando}
        busquedaPlaceholder="Buscar por supervisor..." 
        onAgregar={abrirNuevo}
        onEditar={abrirEditar}
        onEliminar={eliminar}
      />

      <CModal visible={abierto} onClose={() => { setAbierto(false); setEditando(null) }}>
        <CModalHeader>
          <CModalTitle>{editando ? 'Modificar supervisor' : 'Nuevo supervisor'}</CModalTitle>
        </CModalHeader>
        <CModalBody style={{ maxHeight: '75vh', overflowY: 'auto' }}>
          {errorModal && <CAlert color="danger">{errorModal}</CAlert>}
          <CForm ref={formRef} onSubmit={crear}>
            {/* ── TARJETA 1 — DATOS DEL SUPERVISOR ── */}
            <CCard className="mb-3 shadow-sm" style={{ borderRadius: 8 }}>
              <CCardHeader className="d-flex align-items-center gap-2 fw-semibold border-bottom py-2">
                <CIcon icon={cilUser} size="sm" /> Datos del Supervisor
              </CCardHeader>
              <CCardBody style={{ padding: '14px 16px' }}>
                <CRow className="g-3">
                  <CCol md={12}>
                    <CFormLabel>Usuario</CFormLabel>
                    {/* Select del USUARIO (el backend recibe el código —
                        SupervisorNombre = UsuarioCodigo, FK ISUPERVISOR2). */}
                    <CFormSelect
                      value={form.supervisorNombre}
                      onChange={(e) => setForm({ ...form, supervisorNombre: e.target.value })}
                    >
                      <option value="">Seleccione...</option>
                      {usuarios.map((u) => (
                        <option key={u.usuarioCodigo} value={u.usuarioCodigo}>
                          {u.usuarioNombre}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>

            {/* ── TARJETA 2 — PERMISOS ── */}
            <CCard className="mb-3 shadow-sm" style={{ borderRadius: 8 }}>
              <CCardHeader className="d-flex align-items-center gap-2 fw-semibold border-bottom py-2">
                <CIcon icon={cilLockLocked} size="sm" /> Permisos
              </CCardHeader>
              <CCardBody style={{ padding: '14px 16px' }}>
                <CRow className="g-3">
                  <CCol md={6}>
                    {/* SupervisorLibreNumerico1 = combobox GX "y Modificar?"
                        (supervisorgeneral.cs:1252-1255): Solo Crear/Solo Modificar/
                        Crear y Modificar. Los demás libres son solo FILTROS del
                        grid — se ocultan del formulario (decisión Rafael). */}
                    <CFormLabel>y Modificar?</CFormLabel>
                    <CFormSelect value={form.libreNumerico1} onChange={(e) => setForm({ ...form, libreNumerico1: Number(e.target.value) })}>
                      <option value={0}>Seleccione...</option>
                      <option value={1}>Solo Crear</option>
                      <option value={2}>Solo Modificar</option>
                      <option value={3}>Crear y Modificar</option>
                    </CFormSelect>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>

          </CForm>
        </CModalBody>
        <CModalFooter className="border-top">
          <CButton color="secondary" type="button" onClick={() => setAbierto(false)}>Cancelar</CButton>
          <CButton color="primary" type="button" disabled={guardando} onClick={() => formRef.current?.requestSubmit()}>{guardando ? 'Guardando…' : editando ? 'Guardar cambios' : 'Crear supervisor'}</CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default SupervisorPage
